import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function ProductInfoDialog(props) {

    const tableStyle = { border: '1px solid rgba(224, 224, 224, 1)' }
    const tableMainHeadStyle = { backgroundColor: '#7E7E7E', color: 'white', textAlign: 'center' }
    const tableHeadStyle = { backgroundColor: '#00000029', border: '1px solid rgba(224, 224, 224, 1)' }

    return (
        <Dialog open={props.open} onClose={props.onProductInfoDialogClosed} scroll="body">
            <DialogContent className="product-info-dialog-content">
                <IconButton className="product-info-close-button" aria-label="close" onClick={props.onProductInfoDialogClosed}>
                    <CloseIcon />
                </IconButton>

                <h4>Provide your family a financially sound future with Securian’s Secure Promise Whole Life</h4>
                <p>Issued by Minnesota Life Insurance Company, a Securian Company</p>
                <p>You and your family have dreams and goals that may change over time, but protecting your family and loved ones will always be important. Secure Promise is simplified issue permanent life insurance with fixed premiums and guaranteed death benefit protection.</p>
                <h4>Protection for Adults</h4>
                <p>Protect your family while also saving for their future:</p>
                <ul>
                    <li>Less than a $1.50 a day for $50,000 coverage <sup>1</sup></li>
                    <li>Quick, easy coverage – no medical exam <sup>2</sup></li>
                    <li>Guaranteed death benefit</li>
                    <li>Builds tax-deferred cash value</li>
                </ul>
                <h4>Protection for Children</h4>
                <p>Take a step in the right direction – provide a financially sound future for your child:</p>
                <ul>
                    <li>Coverage is guaranteed and doubles at age 18</li>
                    <li>Premiums are locked in based on issue age and never increase</li>
                    <li>Less than 50 cents a day for $25,000 of coverage <sup>3</sup></li>
                    <li>Provides a head start on college savings</li>
                    <li>Opportunities to increase coverage up to 10 times original amount without underwriting</li>
                </ul>
                <h4>Product Options</h4>
                <p>
                    This permanent, Whole Life Insurance policy provides guaranteed protection for the life of the contract. The following features are automatically included in
                    your policy at no additional cost:
                </p>
                <ul>
                    <li>
                        Get early access to a portion of your death benefit coverage in the event of your terminal illness. The Accelerated Benefit for Terminal Illness Agreement
                        (ABA) is included in your policy for no additional charge and with no effect on premium amount.
                    </li>
                    <li>
                        Ensure your protection remains in force even if you miss a payment. The Automatic Premium Loan (APL) Provision allows a policy loan to be taken from your
                        policy to pay the premium due and guarantee the contract will not lapse. The Automatic Premium Loan can only be effective if your policy has available loan
                        value.
                    </li>
                </ul>

                <p>
                    You also have the flexibility to increase your coverage amount, without the need for underwriting, for an additional cost. Provided you are under the age of
                    32, the Guaranteed Insurability Option (GIO) Agreement allows you to add additional coverage by providing a new policy each time you exercise this feature.
                    The new policy will have a new premium and your original premium will remain the same. This feature can be exercised at the ages 25, 28, 31, and 34, or upon
              your date of marriage, or the birth or adoption of a child. <sup>4</sup>
                </p>

                <TableContainer>
                    <Table style={tableStyle} aria-label="Secure Promise Whole Life Product Details">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2} style={tableMainHeadStyle}>Secure Promise Whole Life</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key={0}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Policy</TableCell>
                                <TableCell component="th" scope="row">Non-participating whole life</TableCell>
                            </TableRow>
                            <TableRow key={1}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Issue ages</TableCell>
                                <TableCell component="th" scope="row">
                                    <p>Adults: 18-65 years</p>
                                    <p>Children: 14 days - 17 years</p>
                                </TableCell>
                            </TableRow>
                            <TableRow key={2}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Coverage amounts</TableCell>
                                <TableCell component="th" scope="row">
                                    <p>Adults: $10,000 to $150,000 selected in $5,000 increments</p>
                                    <p>Children: $10,000 to $75,000 selected in $5,000 increments</p>
                                </TableCell>
                            </TableRow>
                            <TableRow key={3}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Guaranteed interest rate</TableCell>
                                <TableCell component="th" scope="row">4.0%</TableCell>
                            </TableRow>
                            <TableRow key={4}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Issue classes</TableCell>
                                <TableCell component="th" scope="row">Standard Non-Tobacco, Standard Tobacco</TableCell>
                            </TableRow>
                            <TableRow key={5}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Premium mode</TableCell>
                                <TableCell component="th" scope="row">Monthly</TableCell>
                            </TableRow>
                            <TableRow key={6}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Payment method</TableCell>
                                <TableCell component="th" scope="row">EFT Only</TableCell>
                            </TableRow>
                            <TableRow key={7}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Minimum base premium</TableCell>
                                <TableCell component="th" scope="row">Greater of $30 and the amount needed to support the requested face amount</TableCell>
                            </TableRow>
                            <TableRow key={8}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Loans</TableCell>
                                <TableCell component="th" scope="row">Fixed</TableCell>
                            </TableRow>
                            <TableRow key={9}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Fixed loan rates</TableCell>
                                <TableCell component="th" scope="row">5.0% interest charged in arrears</TableCell>
                            </TableRow>
                            <TableRow key={10}>
                                <TableCell component="th" scope="row" style={tableHeadStyle}>Available agreements<sup>5</sup></TableCell>
                                <TableCell component="th" scope="row">
                                    Accelerated Benefit Agreement, Automatic Premium Loan Provision Agreement, Guaranteed Insurability Option Agreement
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <div style={{ color: '#7E7E7E', marginTop: '1em' }}>
                    <p><sup>1</sup>For a 24-year-old female, Non-Tobacco. Rates vary by age, gender and tobacco status.</p>
                    <p><sup>2</sup>Decision is based on answers to health questions. </p>
                    <p><sup>3</sup>For an 8-year-old male, Non-Tobacco. Rates vary by age and gender. </p>
                    <p><sup>4</sup>There is a charge for this agreement for issue ages over 18. </p>
                    <p><sup>5</sup>
                Additional agreements may be available. Agreements may be subject to additional cost and restrictions. Agreements may not be available in all states or may
                exist under a different name in various states.
              </p>
                </div>

                <p>Insurance policy guarantees are subject to the financial strength and claims-paying ability of the issuing insurance company.</p>

                <p>13653 DOFU 6-2017</p>

                <small>
            Insurance products are sold through Covr Financial Technologies Inc ("Covr"). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers. Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229). All other state license numbers are available on our <a href='/StateDisclosure' target="_blank">State License Disclosure Page</a>.
            </small>
            </DialogContent>
        </Dialog>
    );
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/Helpers/ProductInfoDialog.js